import { Tooltip } from '@mui/joy';
import { ReactElement } from 'react';

import { Color } from 'theme/enums';

interface IProps {
  disabled?: boolean;
  disabledTooltip?: string;
  children: ReactElement;
}

export const DisabledTooltipWrapper = ({ disabled, disabledTooltip, children }: IProps) => {
  if (disabled && disabledTooltip) {
    return (
      <Tooltip title={disabledTooltip} placement="top" color={Color.WARNING}>
        <span>{children}</span>
      </Tooltip>
    );
  }

  return children;
};
